import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
export function CommunicationsIcon(props) {
    const themeContext = useContext(ThemeContext);
    const { color = 'Grey6', ...rest } = props;
    const primaryFillColor = themeContext.colors[color];
    return (_jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...rest, children: _jsx("path", { clipRule: "evenodd", d: "M3.15 5h18.7v12.75h-8.5L7.4 22v-4.25H3.15V5v0z", stroke: primaryFillColor, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}
//# sourceMappingURL=Communications.js.map